import React from "react"
import { graphql, Link } from "gatsby"
import styles from "@one-builder/gatsby-theme-ob-master/src/styles/global.module.scss"
import { GoTriangleRight } from "react-icons/go"

// Components
import Layout from "@one-builder/gatsby-theme-ob-master/src/components/layout/layout"
import ServiceItems from "@one-builder/gatsby-theme-ob-master/src/components/services/service-items"
import BackgroundImage from "gatsby-background-image"
import TestimonialSlider from "@one-builder/gatsby-theme-ob-master/src/components/home/testimonial-slider"

import { useGetTokens } from "@one-builder/gatsby-theme-ob-master/src/hooks/useGetTokens"
import convertTokens from "@one-builder/gatsby-theme-ob-master/src/helpers/convertTokens"
import setSeoData from "@one-builder/gatsby-theme-ob-master/src/helpers/setSeoData"

import { Fade } from "react-awesome-reveal"

export default ({ data, location }) => {
  // Get metadata
  const metadata = useGetTokens()

  let content = data.content
  let { title, meta } = content.frontmatter
  let services = data.services.edges

  let heroImage
  if (content.frontmatter.heroImage) {
    heroImage = content.frontmatter.heroImage.childImageSharp.fluid
  }

  let seo_data = setSeoData(content.frontmatter)

  return (
    <Layout location={location} seo_data={seo_data}>
      <img src="/images/services-bg.jpg" />
      <div className={styles.container}>
        <h1>{title}</h1>
        <div
          dangerouslySetInnerHTML={{
            __html: convertTokens(content.html, metadata),
          }}
        />
        {services.length > 0 ? (
          <ServiceItems services={services} />
        ) : (
          <p>No services currently available.</p>
        )}
      </div>
      <section
        id={styles.testimonials}
        className={`${styles.row} ${styles.row4} ${styles.subpageTestimonials}`}
      >
        <div className={styles.container}>
          <Fade direction="down" triggerOnce={true}>
            <TestimonialSlider />
          </Fade>
        </div>
      </section>
      <section id={styles.contest} className={`${styles.row} ${styles.row5}`}>
        <div className={styles.container}>
          <div>
            <h1>Leave a Review & <strong>Enter to Win</strong></h1>
            <p>
              Who wants a tone-deaf company? Not Jim Warren and not any of the
              contractors at Warren Construction. We aim to be among the best
              handymen in Northeast Pennsylvania, and we need your help to do it.
              Your feedback helps us know what we should keep doing and where we
              can grow.
            </p>
            <p>
              In return for your time, we're offering a chance to win great
              prizes!
            </p>
          </div>
          <div
            className={styles.hpBtns}
            style={{ padding: 0, marginTop: -100 }}
          >
            <Link to="/feedback/" title="Feedback">
              Leave a Review! <GoTriangleRight />
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export const query = graphql`
  query {
    content: markdownRemark(frontmatter: { title: { eq: "Services" } }) {
      html
      frontmatter {
        title
        heroImage {
          childImageSharp {
            fluid(maxWidth: 1080) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        meta {
          title
          description
          page_visible
        }
      }
    }
    services: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "/(/service_categories/)/" }
        frontmatter: {
          is_active: { eq: true }
          meta: { page_visible: { eq: true } }
        }
      }
      sort: { fields: frontmatter___name }
    ) {
      edges {
        node {
          id
          html
          frontmatter {
            template
            description
            is_active
            name
          }
          fields {
            slug
          }
        }
      }
    }
  }
`
